// extracted by mini-css-extract-plugin
export var container = "index-module--container--x-Fxp";
export var title = "index-module--title--8TUj2";